module.exports = __webpack_public_path__ + "img/智能制造banner1.4611a09d.png";